import React from "react";
import MediaCard from "../../utils/MediaCard";
import { Modal, Form, Button, Row, Col } from "react-bootstrap";
import { useState, useContext } from "react";
import RepoContext from "../../context/Repos";
import GithubCredsForm from "../../Components/GithubCredsForm";
import { githubContents } from "../../APIs/githubApi";
import buildTree from "../../utils/buildFolderTree";
import Spinner from "react-bootstrap/Spinner";
import "./HomeScreen.css";

export const HomeScreen = () => {
  const {
    InputRepo,
    OutputRepo,
    setInputRepo,
    setOutputRepo,
    setInputRepoCreds,
    setOutputRepoCreds,
    setSrcFileTree,
    setDestFileTree,
    initialSelection,
    setInitialSelection,
  } = useContext(RepoContext);
  const [show, setShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const title1 = "Code Migration";
  const text1 =
    "You want to migrate your code from one language/tech-stack to other";
  const imageLink1 =
    "https://wallpapercave.com/wp/wp2234623.jpg";

  const title2 = "Code Refactoring";
  const text2 =
    "You want to revamp your code base, Perform more efficient computation and maintainable code.";
  const imageLink2 =
    "https://i.ytimg.com/vi/6ZylVPzCpaI/maxresdefault.jpg";

  const title3 = "Library Upgrade";
  const text3 =
    "You want to upgrade the libraries/version in your project eg. Angular 2 to Angular 18.";
  const imageLink3 =
    "https://files.constantcontact.com/ed58c47d001/d1438958-00ce-481f-8d7d-2a45ca47045b.jpg";

  // const title4 = "WAF";
  // const text4 =
  //   "You want to generate code according to Well Architected Framework";
  // const imageLink4 =
  //   "https://tse3.mm.bing.net/th/id/OIP.05MHQI-M13_p1qt9VDtbOwHaCT?w=327&h=109&c=7&r=0&o=5&dpr=1.7&pid=1.7";

  const handleClick = (title) => {
    //console.log('Clicked:', title);

    setInitialSelection(title);
    //alert(title);
    setShow(true);
    console.log("Initial Selection state = ", initialSelection);
  };

  const handleClose = () => setShow(false);

  //while production change the values to blank;
  const [form1Data, setForm1Data] = useState({
    username: "",//"Shashank1816",
    patToken: "",//"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",
    repoName: "",//"capitalization_backend",
  });

  const [form2Data, setForm2Data] = useState({
    username: "",//"Shashank1816",
    patToken: "",//"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",
    repoName: "",//"code_migration_destination",
  });

  const handleForm1Change = (e) => {
    const { name, value } = e.target;
    setForm1Data((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleForm2Change = (e) => {
    const { name, value } = e.target;
    setForm2Data((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Perform form submission or any other required action
    if (
      form1Data.username === "" ||
      form1Data.patToken === "" ||
      form1Data.repoName === "" ||
      form2Data.username === "" ||
      form2Data.patToken === "" ||
      form2Data.repoName === ""
    ) {
      alert("Please fill all the fields");
      return;
    }

    setIsLoading(true); // Show loader

    //set Inputrepocreds and outputrepocreds to form1data and form2data
    setInputRepoCreds(form1Data);
    setOutputRepoCreds(form2Data);

    let sourceProject = await githubContents(
      form1Data.username,
      form1Data.patToken,
      form1Data.repoName
    );
    let destinationProject = await githubContents(
      form2Data.username,
      form2Data.patToken,
      form2Data.repoName
    );

    setInputRepo(sourceProject.data);
    setOutputRepo(destinationProject.data);

    const srcTree = await buildTree(
      sourceProject.data,
      form1Data.patToken,
      "input"
    );
    const destTree = await buildTree(
      destinationProject.data,
      form2Data.patToken,
      "output"
    );

    setSrcFileTree([...srcTree]);
    setDestFileTree([...destTree]);

    setIsLoading(false); // Hide loader
    handleClose();
  };

  return (
    <>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Fill in the Github Creds</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col>
              <h5>Source Repo Details</h5>
              <Form onSubmit={handleSubmit}>
                <Form.Group controlId="form1Username">
                  <Form.Label>Github Username</Form.Label>
                  <Form.Control
                    type="text"
                    name="username"
                    placeholder="Enter username"
                    value={form1Data.username}
                    onChange={handleForm1Change}
                  />
                </Form.Group>
                <Form.Group controlId="form1PatToken">
                  <Form.Label>PAT Token</Form.Label>
                  <Form.Control
                    type="text"
                    name="patToken"
                    placeholder="Enter PAT token"
                    value={form1Data.patToken}
                    onChange={handleForm1Change}
                  />
                </Form.Group>
                <Form.Group controlId="form1RepoName">
                  <Form.Label>Repository Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="repoName"
                    placeholder="Enter repository name"
                    value={form1Data.repoName}
                    onChange={handleForm1Change}
                  />
                </Form.Group>
                <hr></hr>
                {/* Add additional form fields for the first form here */}
                {/* <Button variant="primary" type="submit">
                  Submit
                </Button> */}
              </Form>
            </Col>
            <Col>
              <h5>Destination Repo</h5>
              <Form onSubmit={handleSubmit}>
                <Form.Group controlId="form2Username">
                  <Form.Label>Github Username (Destination)</Form.Label>
                  <Form.Control
                    type="text"
                    name="username"
                    placeholder="Enter username"
                    value={form2Data.username}
                    onChange={handleForm2Change}
                  />
                </Form.Group>
                <Form.Group controlId="form2PatToken">
                  <Form.Label>PAT Token (Destination)</Form.Label>
                  <Form.Control
                    type="text"
                    name="patToken"
                    placeholder="Enter PAT token"
                    value={form2Data.patToken}
                    onChange={handleForm2Change}
                  />
                </Form.Group>
                <Form.Group controlId="form2RepoName">
                  <Form.Label>Repository Name (Destination)</Form.Label>
                  <Form.Control
                    type="text"
                    name="repoName"
                    placeholder="Enter repository name"
                    value={form2Data.repoName}
                    onChange={handleForm2Change}
                  />
                </Form.Group>
                {/* Add additional form fields for the second form here */}
                <hr></hr>
                <Button variant="primary" type="submit">
                  {isLoading ? (
                    <Spinner animation="border" role="status"></Spinner>
                  ) : (
                    "Submit"
                  )}
                </Button>
              </Form>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

      <div className="background-container" style={{  marginTop: "4%" }}>
        <table style={{display: "flex", justifyContent: "center", alignItems: "center", marginTop:"5%"}}>
          <tr style={{marginBottom:"30px"}}>
            <td
              onClick={() => handleClick(title1)}
              style={{ cursor: "pointer" }}
            >
              <MediaCard title={title1} text={text1} imageLink={imageLink1} />
            </td>
            <td
              onClick={() => handleClick(title2)}
              style={{ cursor: "pointer" }}
            >
              <MediaCard title={title2} text={text2} imageLink={imageLink2} />
            </td>
            <td
              onClick={() => handleClick(title3)}
              style={{ cursor: "pointer" }}
            >
              <MediaCard title={title3} text={text3} imageLink={imageLink3} />
            </td>
          </tr>
          
        </table>
      </div>

      
    </>
  );
};
